'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nthArg = require('ramda/src/nthArg');

var _nthArg2 = _interopRequireDefault(_nthArg);

var _curried = require('./_curried');

var _fromEagerPromise = require('./fromEagerPromise');

var _fromEagerPromise2 = _interopRequireDefault(_fromEagerPromise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var valueArg = (0, _nthArg2.default)(1);

var last = function last(stream$) {
  return (0, _fromEagerPromise2.default)(function () {
    return (0, _curried.mreducec)(valueArg, void 0, stream$);
  });
};

exports.default = last;

// It is possible that this has some performance issues.
// If this is the case we can investigate using `skipUntil` with
// the original stream being its own signal